var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderRetrivey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 339)",
    fill: "none",
    stroke: "#ffc400",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Order_retrive",
    "data-name": "Order retrive",
    transform: "translate(-19 -339)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7647",
    "data-name": "Group 7647",
    transform: "translate(21.516 341.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7646",
    "data-name": "Group 7646",
    transform: "translate(0.651 0.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8243",
    "data-name": "Path 8243",
    d: "M111.678,342.994v1.2a1.5,1.5,0,0,1-1.5,1.5H101.5a1.5,1.5,0,0,1-1.5-1.5V340",
    transform: "translate(-97.006 -328.023)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8244",
    "data-name": "Path 8244",
    d: "M216,261.5a1.5,1.5,0,1,1,2.994,0,1.5,1.5,0,0,0,1.5,1.5h5.839v-1.5a1.5,1.5,0,0,0-1.5-1.5H217.5",
    transform: "translate(-208.664 -251.017)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8245",
    "data-name": "Path 8245",
    d: "M30.33,261.5a1.5,1.5,0,1,0-2.994,0,1.5,1.5,0,0,1-1.5,1.5H20v-1.5a1.5,1.5,0,0,1,1.5-1.5h7.336",
    transform: "translate(-20 -251.017)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8246",
    "data-name": "Path 8246",
    d: "M136.256,25.988a4.491,4.491,0,1,1,8.472,0",
    transform: "translate(-131.658 -20)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8247",
    "data-name": "Path 8247",
    d: "M323.514,134.777l-2.406,1.782-1.782-2.406",
    transform: "translate(-308.123 -129.881)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderRetrivey);
export default __webpack_public_path__ + "static/media/Order_retrivey.8e3771ac52cef597a2d3d8df768d0460.svg";
export { ForwardRef as ReactComponent };